export const getReversedDirection = (dir: 'top' | 'left' | 'bottom' | 'right') => {
    switch (dir) {
        case 'top':
            return 'bottom';
        case 'left':
            return 'right';
        case 'bottom':
            return 'top';
        case 'right':
            return 'left';
    }
};

export const tableFileTypes = [
    'application/vnd.ms-excel',
    'application/vnd.ms-excel.sheet.macroEnabled.12',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
